import React, { useEffect, useRef, useState } from 'react';
import {
  Card,
  Row,
  Col,
  Form,
  Select,
  Input,
  Space,
  Spin,
  message,
  DatePicker,
  Tooltip,
  Modal
} from 'antd';
import styles from '@/common/Layout/index.module.less';
import { useDispatch } from 'react-redux';
import {
  getProductBatches,
  getProcesses,
  createProducts,
  getProducts,
  downloadpdf,
  // verifyBatch,    // legacy: re-enable to restore Verify Batch flow
  getUsedLotNos,
  regenerateProdLabelPdf
} from '../redux/slice';
import { getBalance } from '@/features/dispensing/redux/slice';
import { getAllDispenseBooths } from '@/features/dispensing/redux/slice';
import Layout from '@/common/Layout';
import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
import { getLoggedInUser } from 'utilities/helpers';
import moment from 'moment';
import {
  CloudDownloadOutlined,
  EditOutlined,
  QrcodeOutlined
} from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { QrReader } from 'react-qr-reader';
import VerificationModal from '@/features/material/components/VerificationModal';
import { compute_gross_weight } from './weights.helper';
const CreateProductLabel = () => {
  const [form, form1] = Form.useForm();
  const dispatch = useDispatch();
  const [productsData, setProductsData] = useState([]);
  const [search, setSearch] = useState('');
  const [processes, setProcesses] = useState([]);
  // const [processDetails, setProcessDetails] = useState([]);
  const [data, setData] = useState();
  const [showNextCard, setShowNextCard] = useState(false);
  const [dispenseBooths, setDispenseBooths] = useState([]);
  const [netWeight, setNetWeight] = useState();
  const [tareWeight, setTareWeight] = useState();
  const [genPdfs, setGenPdfs] = useState([]);
  const [prodLabelsDetails, setProdLabelsDetails] = useState([
    { container_id: '', tare_wt: '', net_Wt: '', gross_weight: '' }
  ]);
  const [prodLabels, setProdLabels] = useState([]);
  const [dataId, setDataId] = useState();
  const [containerId, setContainerId] = useState('');
  const [submittingContainerId, setSubmittingContainerId] = useState(null);
  // Synchronous in-flight guard for onFinish1. The existing <Spin /> swap (rendered
  // based on submittingContainerId) only protects against clicks separated by at
  // least one React re-render. Rapid double-clicks within the same React tick can
  // still fire two form submissions, producing duplicate prod_dispensing_labels
  // rows. A ref-based flag closes that gap without any UI change.
  const submitInFlightRef = useRef(false);
  const [editingContainer, setEditingContainer] = useState(null);
  const [editWeights, setEditWeights] = useState({
    tareWeight: '',
    netWeight: ''
  });
  const [stageData, setStageData] = useState([]);
  const [nextStageData, setNextStageData] = useState([]);
  // isCompression now means "WIP-only" (true for both Compression and Inspection)
  // and drives the free-text-batch / no-DR rendering. labelType disambiguates
  // which flag to persist on submit.
  const [isCompression, setIsCompression] = useState('');
  const [labelType, setLabelType] = useState('');
  // const [showSubimt, setShowSubimt] = useState(false); // legacy: gated submit before verify-batch removal
  const [ipAddress, setIpAddress] = useState('');
  const [portID, setPortID] = useState('');
  const [openCam, setOpenCam] = useState(false);
  const [balancetype, setBalanceType] = useState('');
  const [submitLoading, setSubmitLoading] = useState(false);
  const [usedLots, setUsedLots] = useState([]);
  const [isHeaderEdit, setIsHeaderEdit] = useState(false);
  const [isQAModal, setIsQAModal] = useState(false);
  const [pendingHeaderUpdate, setPendingHeaderUpdate] = useState(null);
  const [originalHeaderValues, setOriginalHeaderValues] = useState(null);
  const [isHeaderDirty, setIsHeaderDirty] = useState(false);
  const [regeneratingLabelId, setRegeneratingLabelId] = useState(null);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [isWeightQAModal, setIsWeightQAModal] = useState(false);
  const [pendingWeightUpdate, setPendingWeightUpdate] = useState(null);
  // Booth id (dispense_booth_id) of the balance selected while a container row
  // is being edited. Kept separate from the header cursor so editing one
  // container never moves the default for the next one.
  const [editBalance, setEditBalance] = useState(null);
  // Target of the QR scanner: 'new' for the container being added, or the id
  // of the saved container under edit. One camera modal serves both.
  const [balanceScanTarget, setBalanceScanTarget] = useState('new');

  const { user } = getLoggedInUser();
  const searchdata = useLocation().search;
  const params = new URLSearchParams(searchdata);
  // Product batches are searchable server-side, so refetch on search change.
  useEffect(() => {
    handleGetProductBatches();
    // handleGetProductLabels();
  }, [search]);

  // Masters (process/stage/next-stage) and dispense booths are fixed lists —
  // fetch once on mount (all rows) and filter client-side.
  useEffect(() => {
    handleGetProcessGroups();
    handleGetStageGroups();
    handleGetNextStageGroups();
    handleGetDispenseBooths();
  }, []);

  console.log(setProdLabelsDetails, prodLabelsDetails);
  useEffect(() => {
    handleGetProductLabelsById();
  }, [genPdfs]);

  // Seed the balance cursor from the MOST RECENT container so the default for
  // the next container is "same balance as the last one" - what operators got
  // when the field was locked. Never overrides a live selection, and the
  // per-container value shown on each row remains the record of what was used.
  useEffect(() => {
    if (ipAddress || !prodLabels?.length || !dispenseBooths?.length) return;
    const last = prodLabels[prodLabels.length - 1];
    if (!last?.weighing_balance) return;
    const booth =
      dispenseBooths.find(
        (b) =>
          b?.ip_address === last.weighing_balance &&
          b?.dispense_booth_id === last.bal_booth_id
      ) || dispenseBooths.find((b) => b?.ip_address === last.weighing_balance);
    if (!booth) return;
    setIpAddress(booth.ip_address);
    setPortID(booth.port);
    setBalanceType(booth.type);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prodLabels, dispenseBooths]);

  const handleGetProductBatches = () => {
    const payload = { search };
    dispatch(getProductBatches(payload)).then((res) => {
      if (res.payload.success) {
        setProductsData(res.payload.data);
      }
    });
  };

  // const handleGetProductLabels = () => {
  //   const payload = { search };
  //   dispatch(getProductBatches(payload)).then((res) => {
  //     if (res.payload.success) {
  //       setProductsData(res.payload.data);
  //     }
  //   });
  // };

  const handleError = (err) => {
    console.error(err);
  };

  const handleQrScan = async (scanData) => {
    if (scanData && scanData !== '') {
      // The QR printed on a balance carries either its IP or its booth id
      // (PRExxx), so both forms are accepted. The scan must resolve to an
      // ACTIVE production balance or it is rejected: the previous version set
      // the raw scanned text as the selection, which left the field showing a
      // bare IP with no matching option (and no port/type behind it), so the
      // next Read would have talked to nothing. Environments do not share the
      // same IPs, so a sticker printed for one plant scans as unknown here.
      const scanned = String(scanData?.text || '').trim();
      // Distinguish "list not loaded" from "unknown balance" - otherwise a failed
      // booth fetch reports every scan as an invalid sticker.
      if (!prodBalances.length) {
        message.error(
          'Balance list has not loaded yet. Close the scanner and try again.'
        );
        setOpenCam(false);
        return;
      }
      const matched = prodBalances.find(
        (b) =>
          String(b?.ip_address || '').trim() === scanned ||
          String(b?.dispense_booth_id || '')
            .trim()
            .toLowerCase() === scanned.toLowerCase()
      );
      if (!matched) {
        message.error(
          `"${scanned}" is not an active production balance. Pick one from the list.`
        );
        setOpenCam(false);
        return;
      }
      // Set from the matched record rather than re-deriving from the IP:
      // ip_address is not unique in dispense_weighings.
      if (balanceScanTarget === 'new') {
        setIpAddress(matched.ip_address);
        setPortID(matched.port);
        setBalanceType(matched.type);
      } else {
        // Editing a saved container: the row selector holds the booth id, and
        // the Read buttons resolve ip/port/type from it, so only this is set.
        setEditBalance(matched.dispense_booth_id);
      }
      message.success(
        `Balance ${matched.balance_name} (${matched.dispense_booth_id}) selected.`
      );
      setOpenCam(false);
      setBalanceScanTarget('new');
    }
  };

  console.log(ipAddress);
  console.log(portID);
  // Dropdown masters are limited lists — fetch ALL active rows (all:true bypasses
  // the default 10-row pagination) once, and filter client-side. This guarantees a
  // saved record's option is always present so the Select shows its label, not the id.
  const handleGetProcessGroups = () => {
    const payload = { type: 'process', all: true };
    dispatch(getProcesses(payload)).then((res) => {
      if (res.payload.success) {
        setProcesses(res.payload.data);
      }
    });
  };

  const handleGetStageGroups = () => {
    const payload = { type: 'stage', all: true };
    dispatch(getProcesses(payload)).then((res) => {
      if (res.payload.success) {
        setStageData(res.payload.data);
      }
    });
  };

  const handleGetNextStageGroups = () => {
    const payload = { type: 'nextStage', all: true };
    dispatch(getProcesses(payload)).then((res) => {
      if (res.payload.success) {
        setNextStageData(res.payload.data);
      }
    });
  };

  const handleGetDispenseBooths = () => {
    dispatch(getAllDispenseBooths()).then((result) => {
      if (result?.payload?.success) {
        setDispenseBooths(result?.payload?.data);
      }
    });
  };

  const handleGetProductLabelsById = () => {
    const payload = { id: data?.id || params.get('id') };
    dispatch(getProducts(payload)).then((result) => {
      if (result?.payload?.success) {
        setProdLabels(result?.payload?.data?.[0]?.prod_dispensing_labels);
        const _label_type = result?.payload?.data?.[0]?.is_inspected
          ? 'inspection'
          : result?.payload?.data?.[0]?.is_compressed
          ? 'compression'
          : 'normal';
        setLabelType(_label_type);
        setIsCompression(
          result?.payload?.data?.[0]?.is_compressed === true ||
            result?.payload?.data?.[0]?.is_inspected === true
        );
        // Compose the same display string the dropdown uses in create mode
        // ("BATCH (Dispense Process › Dispense Subprocess)"). The create-mode
        // dropdown is sourced from dispensing_requests, so its process / subprocess
        // are the DISPENSE process / subprocess. In view mode the row is a
        // prod_dispenses record — the dispense process / subprocess live nested
        // under `dispensing_request` (the controller renames `dispensing-request`
        // → `dispensing_request` before responding).
        const _row = result?.payload?.data?.[0];
        const _dr = _row?.dispensing_request;
        const _processName = _dr?.prod_label_process_master?.process_label_name;
        const _subProcessName = _dr?.prod_label_sub_process?.sub_process_name;
        const _suffix =
          _processName || _subProcessName
            ? ` (${_processName || 'NA'}${
                _subProcessName ? ` › ${_subProcessName}` : ''
              })`
            : '';
        const _displayBatch = `${_row?.batch_no || ''}${_suffix}`;
        params.get('id') &&
          form.setFieldsValue({
            product_batch: _displayBatch,
            label_type: _label_type,
            dispensing_request_id: _displayBatch,
            product_name:
              result?.payload?.data?.[0]?.is_compressed ||
              result?.payload?.data?.[0]?.is_inspected
                ? result?.payload?.data?.[0]?.product_name
                : result?.payload?.data?.[0]?.product_detail?.name,
            prodlabel_process_id:
              result?.payload?.data?.[0]?.prod_label_process_master?.id,
            prodlabel_stage_id:
              result?.payload?.data?.[0]?.prod_label_stage_master?.id,
            prodlabel_nextstage_id:
              result?.payload?.data?.[0]?.prodlabel_nextstage_master?.id,
            bom_process_id: result?.payload?.data?.[0]?.bom_process_master?.id,
            no_of_containers: result?.payload?.data?.[0]?.no_of_containers,
            hold_time:
              result?.payload?.data?.[0]?.hold_time &&
              moment(result?.payload?.data?.[0]?.hold_time).isValid()
                ? moment(result?.payload?.data?.[0]?.hold_time)
                : null,
            batch_size:
              result?.payload?.data?.[0]?.product_detail
                ?.theoretical_batch_size ||
              result?.payload?.data?.[0]?.batch_size,
            lot_no:
              result?.payload?.data?.[0]?.lot_no === '0'
                ? 'NA'
                : `Lot ${result?.payload?.data?.[0]?.lot_no}`
          });
        setDataId(result.payload.data);
        setShowNextCard(true);
      }
    });
  };

  const onFinish = (values) => {
    console.log('Success:', values);
    values['is_compressed'] = labelType === 'compression';
    values['is_inspected'] = labelType === 'inspection';
    setSubmitLoading(true);
    dispatch(createProducts(values))
      .then((res) => {
        setSubmitLoading(false);
        if (res?.payload?.success) {
          form.setFieldsValue({
            dispensing_request_id: values?.dispensing_request_id,
            product_name: values?.product_name,
            bom_process_group_id: values.bom_process_group_id,
            bom_process_id: values.bom_process_id,
            no_of_containers: values.no_of_containers,
            batch_size: values?.batch_size
          });
          setData(res.payload.dispensingRecord);
          setShowNextCard(true);
        } else {
          message.error(
            res?.payload?.message || 'Failed to create. Please try again.'
          );
        }
      })
      .catch(() => {
        setSubmitLoading(false);
        message.error('Failed to create. Please try again.');
      });
  };

  const onFinish1 = (values) => {
    // A row under edit is committed through the QA-verified endpoint, never
    // through this form. Pressing Enter inside a weight input submits the form
    // (a Print & Add submit button is on screen), which would otherwise reach
    // the legacy create endpoint and change a printed attribute unsigned.
    if (editingContainer) {
      return;
    }
    // Synchronous re-entry guard: if a submit is already in flight, drop this one.
    // Protects against rapid double-clicks before React renders the <Spin /> swap.
    if (submitInFlightRef.current) {
      return;
    }
    if (!ipAddress && !prodLabels?.[0]?.weighing_balance) {
      message.error('Select a Weighing Balance before adding a container.');
      return;
    }
    submitInFlightRef.current = true;
    console.log('Success:', data);
    // Track which container is being submitted - use containerId if set, otherwise 'new' for new row
    const currentContainerId =
      containerId || (editingContainer ? editingContainer : 'new');
    setSubmittingContainerId(currentContainerId);

    if (containerId !== '') {
      values['dispense_label_id'] = containerId;
      values['id'] = params.get('id');
    } else {
      values['id'] = data?.id || params.get('id');
    }

    // Use edit weights if in edit mode, otherwise use global state
    const finalTareWeight = editingContainer
      ? editWeights.tareWeight
      : tareWeight;
    const finalNetWeight = editingContainer ? editWeights.netWeight : netWeight;

    values['net_Wt'] = finalNetWeight;
    values['tare_Wt'] = finalTareWeight;
    values['gross_weight'] = compute_gross_weight(
      finalTareWeight,
      finalNetWeight
    );
    // Capture the balance selected right now, not the one on container #1.
    // The backend already resolves and stores the balance per container row;
    // forcing prodLabels[0] here was the only reason every container of a
    // record shared one balance. Falls back to the first container when the
    // operator has not touched the selector this session (previous behaviour).
    values['weighing_balance'] = ipAddress || prodLabels?.[0]?.weighing_balance;
    dispatch(createProducts(values))
      .then((res) => {
        submitInFlightRef.current = false;
        if (res.payload.success) {
          setSubmittingContainerId(null);
          setGenPdfs([...genPdfs, { pdf: res.payload.data }]);
          setTareWeight('');
          setNetWeight('');
          setEditWeights({ tareWeight: '', netWeight: '' });
          setEditingContainer(null);
          setContainerId('');
          console.log('Success:', res.payload.data);
        } else {
          // Reset on error too
          setSubmittingContainerId(null);
        }
      })
      .catch(() => {
        submitInFlightRef.current = false;
        // Reset on error
        setSubmittingContainerId(null);
      });
  };
  const onSearch = (e) => {
    console.log(e);
    setSearch(e);
  };

  // const handleChange = (e) => {
  //   const processes = processGroups.filter((process) => process.id === e);
  //   setProcessDetails(processes?.[0]?.bom_process_masters);
  // };

  const onChange = (e) => {
    const product_name = productsData?.filter((product) => product.id === e);
    console.log(product_name);
    form?.setFieldsValue({
      product_name: product_name?.[0]?.product_detail?.name,
      batch_size: product_name?.[0]?.product_detail?.theoretical_batch_size
    });
  };

  const onChangeLabel = (value) => {
    form.resetFields();
    form.setFieldsValue({ label_type: value });
    setLabelType(value);
    // Compression and Inspection labels are both WIP-only (no DR, free-text batch).
    setIsCompression(value !== 'normal');
  };
  // const onChangeprocess = (e) => {
  // const process = processes?.filter((process) => process.id === e);
  // console.log(process, 'process');
  // setStageData(process?.[0]?.prod_label_stage_masters);
  // };

  // const onChangestage = (e) => {
  // const stage = stageData?.filter((process) => process.id === e);
  // setNextStageData(stage?.[0]?.prodlabel_nextstage_masters);
  // };

  // Only active production balances are selectable. The booth list endpoint
  // already filters to is_active, so this is the bal_type half of the filter.
  const prodBalances = (dispenseBooths || []).filter(
    (b) => b?.bal_type === 'dispense_prod'
  );

  // Display label for a container row stored balance. Prefers the master row
  // matching BOTH stored values (ip + booth id): booth ids are unique among
  // active production balances but not across time, so matching the pair keeps
  // a historical row showing the balance it was actually weighed on.
  const balanceLabelForRow = (row) => {
    if (!row?.bal_booth_id && !row?.weighing_balance) return 'NA';
    const match =
      (dispenseBooths || []).find(
        (b) =>
          b?.dispense_booth_id === row?.bal_booth_id &&
          b?.ip_address === row?.weighing_balance
      ) || prodBalances.find((b) => b?.dispense_booth_id === row?.bal_booth_id);
    return match
      ? `${match.balance_name} (${match.dispense_booth_id})`
      : row?.bal_booth_id || 'NA';
  };

  // True when a row carries a balance that is no longer offered by the booth
  // list (retired, or reclassified off dispense_prod). Such a row gets its
  // stored value rendered as a disabled option so it stays visible and a save
  // that never touches the field cannot silently reassign the balance.
  const isRetiredBalance = (row) =>
    !!row?.bal_booth_id &&
    !prodBalances.some((b) => b?.dispense_booth_id === row?.bal_booth_id);

  const handleEdit = (id) => {
    const item = prodLabels.find((item) => item.id === id);
    if (item) {
      setEditingContainer(id);
      setContainerId(id);
      setEditWeights({
        tareWeight: item.tare_Wt || '',
        netWeight: item.net_Wt || ''
      });
      setEditBalance(item.bal_booth_id || null);
      // Clear global state to prevent interference with new row
      setTareWeight('');
      setNetWeight('');
    }
  };
  // const handleChangeWeight = (e, type) => {
  //   const list = [...productsData];
  //   list[type] = e.target.value;
  //   setProductsData(list);
  // };

  const handleDownloadPdf = (id) => {
    const payload = { id };
    setDownloadLoading(true);
    dispatch(downloadpdf(payload)).then((res) => {
      setDownloadLoading(false);
      if (res?.payload?.success) {
        // window.open(res?.payload?.data, '_blank');
        window.open(
          `${process.env.REACT_APP_STORAGE_URL}${res?.payload?.data
            .split('/')
            .pop()}`,
          '_blank'
        );
      }
    });
  };

  // Verify Batch / Check Lots buttons removed. The backend create_prod_dispensing
  // rejects duplicate (batch + process + stage + next stage + lot_no) combinations
  // on submit. The dropdown also calls fetchUsedLots when opened so already-used
  // lots are visibly disabled to the user.
  const fetchUsedLots = () => {
    const batch = (form.getFieldValue('product_batch') || '')
      .trim()
      .toUpperCase();
    const processId = form.getFieldValue('prodlabel_process_id');
    const stageId = form.getFieldValue('prodlabel_stage_id');
    const nextStageId = form.getFieldValue('prodlabel_nextstage_id');

    if (!batch || !processId || !stageId || !nextStageId) {
      setUsedLots([]);
      return;
    }

    const payload = {
      batch_no: batch,
      prodlabel_process_id: processId,
      prodlabel_stage_id: stageId,
      prodlabel_nextstage_id: nextStageId,
      // Scope used-lot lookup to the label type so inspection lots dedupe
      // independently of compression lots.
      is_inspected: labelType === 'inspection'
    };
    dispatch(getUsedLotNos(payload)).then((res) => {
      if (res?.payload?.success) {
        setUsedLots(res?.payload?.data?.used_lots || []);
      }
    });
  };

  const handleDispenseBooth = (weight_type, containerId = null) => {
    // While a container is under edit its own balance is the source of truth.
    // Reading from the header cursor here would record a weight taken on one
    // balance against a container labelled with another.
    const editBooth =
      containerId && editingContainer === containerId && editBalance
        ? prodBalances.find((b) => b?.dispense_booth_id === editBalance)
        : null;
    const payload = editBooth
      ? { ip: editBooth.ip_address, type: editBooth.type, port: editBooth.port }
      : { ip: ipAddress, type: balancetype, port: portID };
    dispatch(getBalance(payload)).then((response) => {
      if (response?.payload?.success) {
        if (weight_type == 'tare_weight') {
          setTareWeight(response?.payload?.data);
          if (containerId && editingContainer === containerId) {
            setEditWeights((prev) => ({
              ...prev,
              tareWeight: response?.payload?.data
            }));
          }
        } else {
          setNetWeight(response?.payload?.data);
          if (containerId && editingContainer === containerId) {
            setEditWeights((prev) => ({
              ...prev,
              netWeight: response?.payload?.data
            }));
          }
        }
      }
    });
  };

  const handleRegenerateLabelPdf = (labelId) => {
    if (!labelId) return;
    setRegeneratingLabelId(labelId);
    dispatch(regenerateProdLabelPdf({ id: labelId }))
      .then((res) => {
        if (res?.payload?.success && res?.payload?.data) {
          const filename = res.payload.data.split('/').pop();
          window.open(
            `${process.env.REACT_APP_STORAGE_URL}${filename}`,
            '_blank'
          );
        } else {
          message.error(
            res?.payload?.message || 'Failed to regenerate label PDF'
          );
        }
      })
      .finally(() => setRegeneratingLabelId(null));
  };

  const handleInitiateWeightQA = (labelId) => {
    if (!labelId) return;
    if (!editWeights.tareWeight || !editWeights.netWeight) {
      message.error('Enter both Tare Weight and Net Weight');
      return;
    }
    setPendingWeightUpdate({
      id: Number(params.get('id')),
      dispense_label_id: labelId,
      tare_Wt: String(editWeights.tareWeight),
      net_Wt: String(editWeights.netWeight),
      gross_weight: compute_gross_weight(
        editWeights.tareWeight,
        editWeights.netWeight
      ),
      // Booth id, not the IP: ip_address is not unique in dispense_weighings,
      // so the backend resolves the balance by its booth id instead.
      weighing_booth_id: editBalance || null
    });
    setIsWeightQAModal(true);
  };

  const normalizeHeaderValues = (vals) => ({
    prodlabel_nextstage_id: vals?.prodlabel_nextstage_id ?? null,
    hold_time:
      vals?.hold_time && moment.isMoment(vals.hold_time)
        ? vals.hold_time.format('YYYY-MM-DD')
        : vals?.hold_time ?? null,
    lot_no:
      vals?.lot_no === undefined || vals?.lot_no === null
        ? null
        : String(vals.lot_no)
  });

  const recomputeHeaderDirty = () => {
    if (!originalHeaderValues) {
      setIsHeaderDirty(false);
      return;
    }
    const current = form.getFieldsValue([
      'prodlabel_nextstage_id',
      'hold_time',
      'lot_no'
    ]);
    setIsHeaderDirty(
      JSON.stringify(normalizeHeaderValues(current)) !==
        JSON.stringify(normalizeHeaderValues(originalHeaderValues))
    );
  };

  const handleEnterHeaderEdit = () => {
    const snapshot = form.getFieldsValue([
      'prodlabel_nextstage_id',
      'hold_time',
      'lot_no'
    ]);
    setOriginalHeaderValues(snapshot);
    setIsHeaderDirty(false);
    setIsHeaderEdit(true);
  };

  const handleHeaderValuesChange = (changedValues) => {
    if (!isHeaderEdit) return;
    const watched = ['prodlabel_nextstage_id', 'hold_time', 'lot_no'];
    const touched = Object.keys(changedValues).some((k) => watched.includes(k));
    if (!touched) return;
    recomputeHeaderDirty();
  };

  const handleCancelHeaderEdit = () => {
    setIsHeaderEdit(false);
    setIsHeaderDirty(false);
    setOriginalHeaderValues(null);
    handleGetProductLabelsById();
  };

  const handleInitiateHeaderVerification = () => {
    form
      .validateFields(['prodlabel_nextstage_id', 'hold_time', 'lot_no'])
      .then((vals) => {
        const lotRaw = vals?.lot_no;
        const lotNoOut =
          lotRaw === 0 || lotRaw === '0' ? 'N/A' : String(lotRaw);
        setPendingHeaderUpdate({
          id: Number(params.get('id')),
          prodlabel_nextstage_id: vals?.prodlabel_nextstage_id,
          hold_time: vals?.hold_time
            ? moment(vals.hold_time).format('YYYY-MM-DD')
            : null,
          lot_no: lotNoOut
        });
        setIsQAModal(true);
      })
      .catch(() => {});
  };

  const handleBalance = (e) => {
    let booth_details = dispenseBooths.filter((item) => item?.ip_address == e);
    setIpAddress(e);
    setPortID(booth_details?.[0]?.port);
    setBalanceType(booth_details?.[0]?.type);
  };
  console.log(prodLabels);
  return (
    <>
      <Layout sider={false}>
        <Card
          title="Product Details"
          className={`${styles.cardStyles_approver}`}
          extra={
            params.get('id') && !isHeaderEdit ? (
              <Tooltip title="Edit Product Details">
                <CustomButton
                  className={styles.inwardButton}
                  type="primary"
                  size="small"
                  onClick={handleEnterHeaderEdit}
                >
                  <EditOutlined /> Edit
                </CustomButton>
              </Tooltip>
            ) : null
          }
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            onValuesChange={handleHeaderValuesChange}
          >
            <Row gutter={24}>
              <Col span={8}>
                <FormItem
                  label="Label Type"
                  name="label_type"
                  rules={[
                    {
                      required: true,
                      message: 'Select label type'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select label type"
                    onChange={onChangeLabel}
                    disabled={params.get('id')}
                  >
                    <Select.Option value="normal">Others</Select.Option>
                    <Select.Option value="compression">
                      Compression
                    </Select.Option>
                    <Select.Option value="inspection">Inspection</Select.Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>

            <Row gutter={24}>
              {isCompression === false ? (
                <>
                  <Col span={8}>
                    <FormItem
                      label="Product Batch #"
                      name="dispensing_request_id"
                      rules={[
                        {
                          required: true,
                          message: 'Select Product Batch'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Select
                        placeholder="Select Product Batch"
                        showSearch
                        optionFilterProp="children"
                        onChange={onChange}
                        onSearch={onSearch}
                        disabled={params.get('id') ? dataId : data}
                      >
                        {productsData?.map((category, index) => {
                          const processName =
                            category?.prod_label_process_master
                              ?.process_label_name;
                          const subProcessName =
                            category?.prod_label_sub_process?.sub_process_name;
                          const suffix =
                            processName || subProcessName
                              ? ` (${processName || 'NA'}${
                                  subProcessName ? ` › ${subProcessName}` : ''
                                })`
                              : '';
                          return (
                            <option value={category?.id} key={index}>
                              {category?.product_batch_number}
                              {suffix}
                            </option>
                          );
                        })}
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span={16}>
                    <FormItem
                      label="Product name"
                      name="product_name"
                      rules={[
                        {
                          required: true,
                          message: 'Select Product name'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        placeholder=""
                        value=""
                        // disabled={params.get('id') ? dataId : data}
                        disabled
                      />
                    </FormItem>
                  </Col>
                </>
              ) : (
                isCompression === true && (
                  <>
                    <Col span={8}>
                      <FormItem
                        label="Product Batch #"
                        name="product_batch"
                        rules={[
                          {
                            required: true,
                            message: 'Select Product Batch'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <Input
                          placeholder=""
                          value=""
                          disabled={params.get('id')}
                          // disabled
                        />
                      </FormItem>
                    </Col>
                    <Col span={16}>
                      <FormItem
                        label="Product name"
                        name="product_name"
                        rules={[
                          {
                            required: true,
                            message: 'Select Product name'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <Input
                          placeholder=""
                          value=""
                          disabled={params.get('id')}
                          // disabled
                        />
                      </FormItem>
                    </Col>
                  </>
                )
              )}
              {/* <Col span={8}>
                <FormItem
                  label="Process Group"
                  name="bom_process_group_id"
                  rules={[
                    {
                      required: true,
                      message: 'Select Product Batch'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select Process group"
                    onChange={(e) => handleChange(e)}
                    disabled={params.get('id') ? dataId : data}
                  >
                    {processGroups?.map((category, index) => {
                      return (
                        <option value={category?.id} key={index}>
                          {category?.process_group_name}
                        </option>
                      );
                    })}
                  </Select>
                </FormItem>
              </Col> */}
              <Col span={6}>
                <FormItem
                  label="Process"
                  name="prodlabel_process_id"
                  rules={[
                    {
                      required: true,
                      message: 'Select Product Batch'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select Process"
                    disabled={params.get('id') ? dataId : data}
                    showSearch
                    optionFilterProp="children"
                    // onChange={onChangeprocess}
                  >
                    {processes?.map((category, index) => {
                      return (
                        <option value={category?.id} key={index}>
                          {category?.process_label_name}
                        </option>
                      );
                    })}
                  </Select>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Stage"
                  name="prodlabel_stage_id"
                  rules={[
                    {
                      required: true,
                      message: 'Select Product Batch'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select Stage"
                    disabled={params.get('id') ? dataId : data}
                    showSearch
                    optionFilterProp="children"
                    // onChange={onChangestage}
                  >
                    {stageData?.map((category, index) => {
                      return (
                        <option value={category?.id} key={index}>
                          {category?.prodlabel_stage_name}
                        </option>
                      );
                    })}
                  </Select>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Next Stage"
                  name="prodlabel_nextstage_id"
                  rules={[
                    {
                      required: true,
                      message: 'Select Next Stage'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select Next Stage"
                    disabled={params.get('id') ? !isHeaderEdit && dataId : data}
                    showSearch
                    optionFilterProp="children"
                  >
                    {nextStageData?.map((category, index) => {
                      return (
                        <option value={category?.id} key={index}>
                          {category?.prodlabel_nextstage}
                        </option>
                      );
                    })}
                  </Select>
                </FormItem>
              </Col>

              <Col span={6}>
                <FormItem
                  label="No of Containers"
                  name="no_of_containers"
                  rules={[
                    {
                      required: true,
                      message: 'Select Product Batch'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select No of Containers"
                    disabled={params.get('id') ? dataId : data}
                    showSearch
                  >
                    {Array.from({ length: 301 }, (_, i) => i).map((i) => {
                      return (
                        <option value={i} key={i}>
                          {i}
                        </option>
                      );
                    })}
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <FormItem
                  label="Hold time"
                  name="hold_time"
                  rules={[
                    {
                      required: false,
                      message: 'Select Hold time'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <DatePicker
                    style={{
                      width: '100%'
                    }}
                    disabled={params.get('id') && !isHeaderEdit}
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Batch size"
                  name="batch_size"
                  rules={[
                    {
                      required: true,
                      message: 'Enter batch size'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Input
                    placeholder=""
                    value=""
                    // disabled={params.get('id') ? dataId : data}
                    disabled={params.get('id') || !isCompression}
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Lot number"
                  name="lot_no"
                  rules={[
                    {
                      required: true,
                      message: 'Select Lot number'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select Lot number"
                    showSearch
                    disabled={params.get('id') && !isHeaderEdit}
                    onDropdownVisibleChange={(open) => {
                      if (open && isCompression) {
                        fetchUsedLots();
                      }
                    }}
                  >
                    {Array.from({ length: 11 }, (_, i) => i).map((i) => {
                      const isUsed = i !== 0 && usedLots.includes(String(i));
                      const label = i == 0 ? 'NA' : `Lot ${i}`;
                      return (
                        <option value={i} key={i} disabled={isUsed}>
                          {isUsed ? `${label} (already used)` : label}
                        </option>
                      );
                    })}
                  </Select>
                </FormItem>
              </Col>
            </Row>
            {params.get('id')
              ? !dataId
              : !data && (
                  <FormItem className="text-center">
                    <Space>
                      <CustomButton
                        className={styles.inwardButton}
                        htmlType="submit"
                        type="primary"
                        loading={submitLoading}
                        // Verify-batch gating removed; submit is enabled by default.
                        // disabled={isCompression ? !showSubimt : false}
                      >
                        Proceed to Weighing
                      </CustomButton>
                      <CustomButton
                        className={styles.inwardButton}
                        type="primary"
                        ghost
                        onClick={() => history.back()}
                      >
                        Back
                      </CustomButton>
                    </Space>
                  </FormItem>
                )}
            {params.get('id') && isHeaderEdit && (
              <FormItem className="text-center">
                <Space>
                  {isHeaderDirty && (
                    <CustomButton
                      className={styles.inwardButton}
                      type="primary"
                      onClick={handleInitiateHeaderVerification}
                    >
                      Initiate Verification
                    </CustomButton>
                  )}
                  <CustomButton
                    className={styles.inwardButton}
                    type="primary"
                    ghost
                    onClick={handleCancelHeaderEdit}
                  >
                    Cancel
                  </CustomButton>
                </Space>
              </FormItem>
            )}
          </Form>
        </Card>
        {showNextCard && (
          <Card
            title="Weighing Details"
            className={`${styles.cardStyles_approver}`}
          >
            <Form form={form1} layout="vertical" onFinish={onFinish1}>
              <Row gutter={24}>
                <Col span={8}>
                  <FormItem
                    label="Performed By"
                    rules={[
                      {
                        required: false,
                        message: 'Select Product name'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input
                      placeholder=""
                      value={
                        prodLabels?.[0]?.performed_by
                          ? prodLabels[0].performed_by
                          : `${user?.employee} ( ${moment().format(
                              'YYYY-MM-DD'
                            )})`
                      }
                      disabled
                    />
                  </FormItem>
                </Col>
              </Row>
              {/* {Array.from({ length: 5 }, (_, i) => i).map((i) => {
                return ( */}
              {console.log(prodLabels)}
              {prodLabels?.length > 0
                ? prodLabels?.map((item, index) => {
                    return (
                      <Row gutter={24} key={index}>
                        <Col span={4}>
                          <FormItem
                            label="Container ID"
                            className={styles.customLable}
                          >
                            <Input
                              placeholder=""
                              value={item?.prod_containers}
                              disabled
                            />
                          </FormItem>
                        </Col>
                        <Col span={5}>
                          <FormItem
                            label="Weighing Balance"
                            className={styles.customLable}
                          >
                            {editingContainer === item.id ? (
                              <>
                                <Select
                                  placeholder="Select Weighing Balance"
                                  value={editBalance || undefined}
                                  onChange={(value) => setEditBalance(value)}
                                >
                                  {prodBalances.map((b, i) => (
                                    <option
                                      value={b?.dispense_booth_id}
                                      key={i}
                                    >
                                      {`${b?.balance_name} (${b?.dispense_booth_id})`}
                                    </option>
                                  ))}
                                  {isRetiredBalance(item) ? (
                                    <option value={item?.bal_booth_id} disabled>
                                      {`${balanceLabelForRow(item)} - retired`}
                                    </option>
                                  ) : null}
                                </Select>
                                <CustomButton
                                  style={{
                                    color: '#c91761',
                                    marginTop: '2px'
                                  }}
                                  size={'small'}
                                  onClick={() => {
                                    setBalanceScanTarget(item.id);
                                    setOpenCam(true);
                                  }}
                                >
                                  <QrcodeOutlined /> Scan
                                </CustomButton>
                              </>
                            ) : (
                              <Input
                                placeholder=""
                                value={balanceLabelForRow(item)}
                                disabled
                              />
                            )}
                          </FormItem>
                        </Col>
                        <Col span={4}>
                          <FormItem
                            label="Tare Weight"
                            rules={[
                              {
                                required: true,
                                message: 'Select Product Batch'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            {editingContainer === item.id ? (
                              <>
                                <Input
                                  type="number"
                                  step="any"
                                  min={0}
                                  onWheel={(e) => e.target.blur()}
                                  placeholder="Tare Weight"
                                  value={editWeights.tareWeight}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setEditWeights((prev) => ({
                                      ...prev,
                                      tareWeight: value
                                    }));
                                    setTareWeight(value);
                                  }}
                                />
                                <CustomButton
                                  style={{
                                    color: '#c91761',
                                    marginTop: '2px'
                                  }}
                                  size={'small'}
                                  onClick={() =>
                                    handleDispenseBooth('tare_weight', item.id)
                                  }
                                >
                                  Read
                                </CustomButton>
                              </>
                            ) : !item?.tare_Wt ? (
                              <>
                                <Input
                                  type="number"
                                  step="any"
                                  min={0}
                                  onWheel={(e) => e.target.blur()}
                                  placeholder="Tare Weight"
                                  value={
                                    index === prodLabels.length - 1 &&
                                    !editingContainer
                                      ? tareWeight
                                      : ''
                                  }
                                  onChange={(e) =>
                                    setTareWeight(e.target.value)
                                  }
                                />
                                <CustomButton
                                  style={{
                                    color: '#c91761',
                                    marginTop: '2px'
                                  }}
                                  size={'small'}
                                  onClick={() =>
                                    handleDispenseBooth('tare_weight')
                                  }
                                >
                                  Read
                                </CustomButton>
                              </>
                            ) : (
                              <>
                                <Input
                                  placeholder="Tare Weight"
                                  value={item?.tare_Wt}
                                  disabled
                                />
                              </>
                            )}
                          </FormItem>
                        </Col>
                        <Col span={4}>
                          <FormItem
                            label="Net Weight"
                            rules={[
                              {
                                required: true,
                                message: 'Select Product Batch'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            {editingContainer === item.id ? (
                              <>
                                <Input
                                  type="number"
                                  step="any"
                                  min={0}
                                  onWheel={(e) => e.target.blur()}
                                  placeholder="Net Weight"
                                  value={editWeights.netWeight}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setEditWeights((prev) => ({
                                      ...prev,
                                      netWeight: value
                                    }));
                                    setNetWeight(value);
                                  }}
                                />
                                <CustomButton
                                  style={{
                                    color: '#c91761',
                                    marginTop: '2px'
                                  }}
                                  size={'small'}
                                  onClick={() =>
                                    handleDispenseBooth('net_weight', item.id)
                                  }
                                >
                                  Read
                                </CustomButton>
                              </>
                            ) : !item?.net_Wt ? (
                              <>
                                <Input
                                  type="number"
                                  step="any"
                                  min={0}
                                  onWheel={(e) => e.target.blur()}
                                  placeholder="Net Weight"
                                  value={
                                    index === prodLabels.length - 1 &&
                                    !editingContainer
                                      ? netWeight
                                      : ''
                                  }
                                  onChange={(e) => setNetWeight(e.target.value)}
                                />
                                <CustomButton
                                  style={{
                                    color: '#c91761',
                                    marginTop: '2px'
                                  }}
                                  size={'small'}
                                  onClick={() =>
                                    handleDispenseBooth('net_weight')
                                  }
                                >
                                  Read
                                </CustomButton>
                              </>
                            ) : (
                              <Input
                                placeholder="Net Weight"
                                value={item?.net_Wt}
                                disabled
                              />
                            )}
                          </FormItem>
                        </Col>
                        <Col span={3}>
                          <FormItem
                            label="Gross Weight"
                            // name="gross_weight"
                            rules={[
                              {
                                required: false,
                                message: 'Select Product Batch'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Input
                              placeholder="Gross Weight"
                              value={
                                (editingContainer === item.id
                                  ? compute_gross_weight(
                                      editWeights.tareWeight,
                                      editWeights.netWeight
                                    )
                                  : item?.tare_Wt || item?.net_Wt
                                  ? // Saved rows show the stored value so the
                                    // screen matches the printed label; legacy
                                    // rows were rounded to 2 decimals and would
                                    // not survive a recompute.
                                    item?.gross_weight ||
                                    compute_gross_weight(
                                      item?.tare_Wt,
                                      item?.net_Wt
                                    )
                                  : index === prodLabels.length - 1 &&
                                    !editingContainer
                                  ? compute_gross_weight(tareWeight, netWeight)
                                  : '') || '0.00'
                              }
                              disabled
                            />
                          </FormItem>
                        </Col>

                        <Col span={4}>
                          <FormItem
                            className="text-center"
                            style={{ marginTop: '28px' }}
                          >
                            {editingContainer === item.id ? (
                              <CustomButton
                                className={styles.inwardButton}
                                type="primary"
                                disabled={
                                  !editWeights.tareWeight ||
                                  !editWeights.netWeight
                                }
                                onClick={() => handleInitiateWeightQA(item.id)}
                              >
                                Verify QA
                              </CustomButton>
                            ) : !item?.net_Wt ? (
                              submittingContainerId === item.id ? (
                                <Spin />
                              ) : (
                                <CustomButton
                                  className={styles.inwardButton}
                                  htmlType="submit"
                                  type="primary"
                                  onClick={() => {
                                    setContainerId(item.id);
                                  }}
                                >
                                  Print & Add
                                </CustomButton>
                              )
                            ) : (
                              <Space>
                                <Tooltip title="Download Label PDF">
                                  <CustomButton
                                    className={styles.inwardButton}
                                    type="primary"
                                    loading={regeneratingLabelId === item.id}
                                    disabled={
                                      regeneratingLabelId !== null &&
                                      regeneratingLabelId !== item.id
                                    }
                                    onClick={() =>
                                      handleRegenerateLabelPdf(item.id)
                                    }
                                  >
                                    <CloudDownloadOutlined />
                                  </CustomButton>
                                </Tooltip>
                                {params.get('id') && (
                                  <Tooltip title="Edit Weights">
                                    <CustomButton
                                      className={styles.inwardButton}
                                      type="primary"
                                      onClick={() => handleEdit(item.id)}
                                    >
                                      <EditOutlined />
                                    </CustomButton>
                                  </Tooltip>
                                )}
                              </Space>
                            )}
                          </FormItem>
                        </Col>
                      </Row>
                    );
                  })
                : ''}
              {console.log(prodLabels?.length, dataId?.[0]?.no_of_containers)}
              {prodLabels?.length <
              (data?.no_of_containers || dataId?.[0]?.no_of_containers) ? (
                <Row gutter={24}>
                  <Col span={4}>
                    <FormItem
                      label="Container ID"
                      name=""
                      rules={[
                        {
                          required: false,
                          message: 'Select Product Batch'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input placeholder="" value="" disabled />
                    </FormItem>
                  </Col>
                  <Col span={5}>
                    <FormItem
                      label="Weighing Balance"
                      className={styles.customLable}
                    >
                      <Select
                        placeholder="Select Weighing Balance"
                        value={ipAddress || undefined}
                        onChange={(e) => handleBalance(e)}
                        disabled={!!editingContainer}
                      >
                        {prodBalances.map((b, i) => (
                          <option value={b?.ip_address} key={i}>
                            {`${b?.balance_name} (${b?.dispense_booth_id})`}
                          </option>
                        ))}
                      </Select>
                      <CustomButton
                        style={{
                          color: '#c91761',
                          marginTop: '2px'
                        }}
                        size={'small'}
                        onClick={() => {
                          setBalanceScanTarget('new');
                          setOpenCam(true);
                        }}
                        disabled={!!editingContainer}
                      >
                        <QrcodeOutlined /> Scan
                      </CustomButton>
                    </FormItem>
                  </Col>
                  <Col span={4}>
                    <FormItem
                      label="Tare Weight"
                      // name="tare_Wt"
                      rules={[
                        {
                          required: true,
                          message: 'Select Product Batch'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        type="number"
                        step="any"
                        min={0}
                        onWheel={(e) => e.target.blur()}
                        placeholder="Tare Weight"
                        value={editingContainer ? '' : tareWeight}
                        onChange={(e) => setTareWeight(e.target.value)}
                        disabled={!!editingContainer}
                      />
                      <CustomButton
                        style={{
                          color: '#c91761',
                          marginTop: '2px'
                        }}
                        size={'small'}
                        onClick={() => handleDispenseBooth('tare_weight')}
                        disabled={!!editingContainer}
                      >
                        Read
                      </CustomButton>
                    </FormItem>
                  </Col>
                  <Col span={4}>
                    <FormItem
                      label="Net Weight"
                      // name="net_Wt"
                      rules={[
                        {
                          required: true,
                          message: 'Select Product Batch'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        type="number"
                        step="any"
                        min={0}
                        onWheel={(e) => e.target.blur()}
                        placeholder="Net Weight"
                        value={editingContainer ? '' : netWeight}
                        onChange={(e) => setNetWeight(e.target.value)}
                        disabled={!!editingContainer}
                      />
                      <CustomButton
                        style={{
                          color: '#c91761',
                          marginTop: '2px'
                        }}
                        size={'small'}
                        onClick={() => handleDispenseBooth('net_weight')}
                        disabled={!!editingContainer}
                      >
                        Read
                      </CustomButton>
                    </FormItem>
                  </Col>
                  <Col span={3}>
                    <FormItem
                      label="Gross Weight"
                      // name="gross_weight"
                      rules={[
                        {
                          required: false,
                          message: 'Select Product Batch'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        placeholder="Gross Weight"
                        value={
                          editingContainer
                            ? '0.00'
                            : compute_gross_weight(tareWeight, netWeight) ||
                              '0.00'
                        }
                        disabled
                      />
                    </FormItem>
                  </Col>
                  <Col span={4}>
                    <FormItem
                      className="text-center"
                      style={{ marginTop: '28px' }}
                    >
                      <Space>
                        {submittingContainerId === 'new' ? (
                          <Spin />
                        ) : (
                          <CustomButton
                            className={styles.inwardButton}
                            htmlType="submit"
                            type="primary"
                            disabled={
                              editingContainer || !tareWeight || !netWeight
                            }
                            onClick={() => {
                              setContainerId('');
                            }}
                          >
                            Print & Add
                          </CustomButton>
                        )}
                      </Space>
                    </FormItem>
                  </Col>
                </Row>
              ) : (
                ''
              )}
              {/* <Col span={4}> */}
              <FormItem className="text-center" style={{ marginTop: '28px' }}>
                <Space>
                  {params.get('id') && (
                    <Tooltip title="Download Weighing Report">
                      <CustomButton
                        className={styles.inwardButton}
                        type="primary"
                        loading={downloadLoading}
                        disabled={downloadLoading}
                        onClick={() => handleDownloadPdf(params.get('id'))}
                      >
                        <CloudDownloadOutlined />
                      </CustomButton>
                    </Tooltip>
                  )}
                  <CustomButton
                    className={styles.inwardButton}
                    onClick={() => history.back()}
                    type="primary"
                  >
                    Back
                  </CustomButton>
                </Space>
              </FormItem>
              {/* </Col> */}
              {/* );
              })} */}
              <Modal
                title="Scan QR Code"
                visible={openCam}
                onCancel={() => {
                  setOpenCam(false);
                  setBalanceScanTarget('new');
                }}
                footer={null}
                destroyOnClose
                centered
                width={420}
              >
                {openCam && (
                  <QrReader
                    constraints={{
                      facingMode: 'environment'
                    }}
                    delay={300}
                    onError={handleError}
                    onResult={(result) => handleQrScan(result)}
                    style={{
                      width: '100%',
                      height: 'auto'
                    }}
                  />
                )}
              </Modal>
            </Form>
          </Card>
        )}
      </Layout>
      {isQAModal && (
        <VerificationModal
          isModal={isQAModal}
          setIsModal={setIsQAModal}
          material={pendingHeaderUpdate}
          setIsEdit={setIsHeaderEdit}
          page="prod_label_update"
        />
      )}
      {isWeightQAModal && (
        <VerificationModal
          isModal={isWeightQAModal}
          setIsModal={setIsWeightQAModal}
          material={pendingWeightUpdate}
          setIsEdit={(v) => {
            if (!v) {
              setEditingContainer(null);
              setContainerId('');
              setEditWeights({ tareWeight: '', netWeight: '' });
              setEditBalance(null);
            }
          }}
          page="prod_label_weight_update"
        />
      )}
    </>
  );
};
export default CreateProductLabel;
